import assertString from "./utils/assertString";
import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";

export default function isEnglishAlphabet(str, responseText) {
    const regVal = regexList.engName.pattern;
    return regexTest(str, regVal, responseText) || regexList.engName.response;
}

